/**
 * Set-up toggle buttons.
 */
export function setup() {
	const mapButton = document.querySelector('[data-trigger="map"]');
	const listButton = document.querySelector('[data-trigger="list"]');
	const mapContainer = document.querySelector('[data-container="map"]');
	const listContainer = document.querySelector('[data-container="list"]');
	for (const button of [mapButton, listButton]) {
		button.addEventListener('change', () => {
			const isList = listButton.checked;
			mapButton.setAttribute('aria-selected', isList ? 'false' : 'true');
			listButton.setAttribute('aria-selected', isList ? 'true' : 'false');
			mapContainer.classList.toggle('d-none', isList);
			listContainer.classList.toggle('d-none', !isList);
		});
	}
}
